import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Box, Stack, Typography } from "@mui/material";

import { RouteButton, RouteMUILink } from "@/components/common/styles";
import {
  usePlanTierSelection,
  PlanTierRow,
} from "@/components/planPricing/planTiers";
import { TProxyTabType } from "@/components/newcustomize/utils/makeProxyTabType";

/**
 * The dashboard flavor of a product's purchase flow (r-1776): the Popular
 * Plans tier selection with the Buy Now action in the heading row and the
 * "Need a Different plan?" footer in its own divided row. Reuses the tier
 * pricing/selection logic from the Proxy List inactive state.
 */
export default function PopularPlansSelector({
  planKey,
}: {
  planKey: TProxyTabType;
}) {
  const {
    plan,
    selectedIndex,
    setSelectedIndex,
    selectedPlan,
    buyNowHref,
    isLoading,
  } = usePlanTierSelection(planKey);

  if (!plan) return null;

  return (
    <Box>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
        sx={{ p: 3, pb: 0 }}
      >
        <Typography variant="h6">Popular Plans</Typography>
        <RouteButton
          {...buyNowHref}
          variant="contained"
          color="primary"
          loading={isLoading}
          disabled={selectedPlan?.isOutOfStock}
          endIcon={<ChevronRightIcon fontSize="small" />}
        >
          Buy Now
        </RouteButton>
      </Stack>
      <PlanTierRow
        plans={plan.plans}
        selectedIndex={selectedIndex}
        onSelect={setSelectedIndex}
        spacing={2}
        sx={{ p: 3 }}
      />
      <Stack
        direction="row"
        alignItems="center"
        flexWrap="wrap"
        useFlexGap
        spacing={2}
        sx={{ p: 3, borderTop: 1, borderColor: "divider" }}
      >
        <Typography variant="body1" fontWeight={500}>
          Need a Different plan?
        </Typography>
        <RouteMUILink variant="body1" to="/subscription/choose-plan">
          Check Pricing For All Plans
        </RouteMUILink>
      </Stack>
    </Box>
  );
}
